<template>
    <b-form-group :label="label">
        <b-input-group>
            <cleave v-model="cleaveValue" :class="state === false || stateTwo === false ? 'form-control error': 'form-control'"
                    :raw="false" :options="timeFormat" placeholder="HH:mm" :disabled="disabled" />
            <b-input-group-append>
                <b-form-timepicker v-model="pickerValue" :hour12="false" button-only right label-help="" label-no-date-selected=""
                                   dropright size="sm" locale="en" aria-controls="example-input" :disabled="disabled" />
            </b-input-group-append>
            <b-form-invalid-feedback :state="state">
                {{feedback}}
            </b-form-invalid-feedback>
            <b-form-invalid-feedback :state="stateTwo">
                {{feedbackTwo}}
            </b-form-invalid-feedback>
        </b-input-group>
    </b-form-group>
</template>

<script>
export default {
    props: {
        label: { type: String, default: '' },
        feedback: { type: String, default: '' },
        state: { type: Boolean, default: true },
        feedbackTwo: { type: String, default: '' },
        stateTwo: { type: Boolean, default: true },
        initialValue: { type: String, default: '' },
        disabled: { type: Boolean, default: false },
    },

    data() {
        return {
            value: '',
            cleaveValue: null,
            timeFormat: {
                time: true,
                timePattern: ['h', 'm'],
                onValueChanged: (e) => {this.onCleaveValueChanged(e);},
            },
        }
    },

    mounted() {
        if((this.initialValue || null) !== null) {
            const tmpTimeHM = this.initialValue.split(':');
            this.cleaveValue = tmpTimeHM[0]+':'+tmpTimeHM[1];
            this.value = tmpTimeHM[0]+':'+tmpTimeHM[1];
        }
    },

    computed: {
        pickerValue: {
            set: function(val) {
                const tmpTimeHM = val.split(':');
                this.cleaveValue = tmpTimeHM[0]+':'+tmpTimeHM[1];
                this.value = tmpTimeHM[0]+':'+tmpTimeHM[1];
            },
            get: function() {
                return this.value;
            },
        },
    },

    methods: {
        onCleaveValueChanged(e) {
            if(e.target.rawValue.length === 4) {
                this.value = e.target.value;
                this.$emit('value-change', e.target.value);
            }
            else {
                this.value = '';
                this.$emit('value-change', '');
            }
        },
    },
}
</script>

<style scoped>
.error {
    border-color: #ea5455
}
</style>
